import { defineMessages } from 'react-intl'

const scope = `procurify.components.FinancialAccountSummaryCard`

export default defineMessages({
  accountBalanceLabel: {
    id: `${scope}.accountBalanceLabel`,
    defaultMessage: 'Account balance',
  },
  allocatedFundsLabel: {
    id: `${scope}.allocatedFundsLabel`,
    defaultMessage: 'Allocated funds',
  },
  availableFundsLabel: {
    id: `${scope}.availableFundsLabel`,
    defaultMessage: 'Available funds',
  },
  upcomingPaymentsLabel: {
    id: `${scope}.upcomingPaymentsLabel`,
    defaultMessage: 'Upcoming payments',
  },
  spendingCardsLabel: {
    id: `${scope}.spendingCardsLabel`,
    defaultMessage: 'Spending cards',
  },
  availableFundsTooltipLabel: {
    id: `${scope}.availableFundsTooltipLabel`,
    defaultMessage: 'More information about available funds',
  },
  availableFundsSpendingCardsPaymentsTooltipText: {
    id: `${scope}.availableFundsSpendingCardsPaymentsTooltipText`,
    defaultMessage:
      'Funds available to be used for spending cards and payments',
  },
  availableFundsSpendingCardsTooltipText: {
    id: `${scope}.availableFundsSpendingCardsTooltipText`,
    defaultMessage: 'Funds available to be used for spending cards',
  },
  availableFundsPaymentsTooltipText: {
    id: `${scope}.availableFundsPaymentsTooltipText`,
    defaultMessage: 'Funds available to be used for payments',
  },
  inactiveAccountLabel: {
    id: `${scope}.inactiveAccountLabel`,
    defaultMessage: 'Inactive account',
  },
  insufficientFundsLabel: {
    id: `${scope}.insufficientFundsLabel`,
    defaultMessage: 'Insufficient funds',
  },
  addFundsButton: {
    id: `${scope}.addFundsButton`,
    defaultMessage: 'Add funds',
  },
  setUpAccountButton: {
    id: `${scope}.setUpAccountButton`,
    defaultMessage: 'Set up account',
  },
  flagAltTextUs: {
    id: `${scope}.flagAltTextUs`,
    defaultMessage: 'US flag',
  },
  flagAltTextCanada: {
    id: `${scope}.flagAltTextCanada`,
    defaultMessage: 'Canada flag',
  },
  flagAltTextUk: {
    id: `${scope}.flagAltTextUk`,
    defaultMessage: 'UK flag',
  },
  showBalanceButtonText: {
    id: `${scope}.showBalanceButtonText`,
    defaultMessage: 'Show balance',
  },
  verifyIdentityErrorToastMessage: {
    id: `${scope}.verifyIdentityErrorToastMessage`,
    defaultMessage: 'Your identity could not be verified',
  },
})
